import { createContext } from 'react'

/**
 * Context to get / set menu collapsed state
 */
export const MenuCollapsedState = createContext([
  false,
  collapsed => void collapsed,
])
